import 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface InvoicePopupModalState {
  openInvoicePopupModal: boolean;
  loading: boolean;
}

// Initialize state
const initialState: InvoicePopupModalState = {
  openInvoicePopupModal: false,
  loading: false,
};

export const invoicePopupModalSlice = createSlice({
  name: 'invoicePopupModal',
  initialState,
  reducers: {
    openInvoicePopupModal: (state) => ({
      ...state,
      openInvoicePopupModal: true,
    }),
    closeModal: () => ({
      ...initialState,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
  },
});

export const { openInvoicePopupModal, closeModal, setLoading } =
  invoicePopupModalSlice.actions;
export default invoicePopupModalSlice.reducer;
